// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile/PersonPaymentAccount/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_Payors_Content_Payors_Payor_Content_Content_Profile_PersonPaymentAccount($payment_account_id: numeric!) {
  vaxiom_person_payment_accounts_by_pk(id: $payment_account_id) {
    id
    payer_person {
      id
      _id
      gender
      greeting
      first_name
      last_name
      profile_pic_url
      birth_date
      patient {
        id
        _id
        human_readable_id
        tx_cards(where: { deleted: { _eq: false } }) {
          id
          txs(where: { deleted: { _eq: false } }) {
            id
            organization {
              id
              _id
              name
            }
          }
        }
      }
    }
  }
}

`